import React from "react";
import { Goal } from "../../../../../types/goal";
import "./AssessmentGrid.scss";

export interface AssessmentGridColumn {
  key: string;
  header: React.ReactNode;
  render: (goal: Goal) => React.ReactNode;
  isSticky?: boolean;
}

interface AssessmentGridProps {
  goals: Goal[];
  columns: AssessmentGridColumn[];
  columnsPerView?: number;
}

const AssessmentGrid: React.FC<AssessmentGridProps> = ({
  goals,
  columns,
  columnsPerView = 2,
}) => {
  const colCount = columns.length;
  const isCompact = columnsPerView >= 3;

  return (
    <div
      className={`assessment-grid-wrapper${
        isCompact ? " assessment-grid-wrapper--fit" : ""
      }`}
    >
      <div
        className={`assessment-grid${isCompact ? " assessment-grid--compact" : ""}`}
        style={{ "--col-count": colCount } as React.CSSProperties}
      >
        <div className="assessment-grid__header">
          {columns.map((col) => (
            <div
              key={col.key}
              className={`assessment-grid__header-cell ${
                col.isSticky ? "assessment-grid__header-cell--sticky" : ""
              }`}
            >
              {col.header}
            </div>
          ))}
        </div>

        {goals.map((goal) => (
          <div key={goal.id} className="assessment-grid__row">
            {columns.map((col) => (
              <div
                key={`${goal.id}-${col.key}`}
                className={`assessment-grid__cell ${
                  col.isSticky ? "assessment-grid__cell--sticky" : ""
                }`}
              >
                {col.render(goal)}
              </div>
            ))}
          </div>
        ))}

        {goals.length === 0 && (
          <div
            className="assessment-grid__empty"
            style={{ gridColumn: `1 / ${colCount + 1}` }}
          >
            No goals available
          </div>
        )}
      </div>
    </div>
  );
};

export default AssessmentGrid;
